import type { SchoolCandidateNewResidencesRequest } from "../../../queries";
import {
  useDownloadSchoolCandidateResidencesMutation,
  useLazyGetSchoolCandidateNewResidencesQuery,
  useSaveInstitutionAssignmentMutation,
  useSetInstitutionAssignmentMutation,
  useStartSchoolCandidateBatchMutation,
} from "../../../queries";
import { useAuthCounties } from "../../../hooks";

export const useSchoolCandidateAddressAccess = () => {
  const authCounties = useAuthCounties();

  const [
    triggerGetSchoolCandidateNewResidences,
    {
      data: schoolCandidateNewResidences,
      isFetching: isSchoolCandidateNewResidencesFetching,
    },
  ] = useLazyGetSchoolCandidateNewResidencesQuery();

  const [startSchoolCandidateBatchRequest] =
    useStartSchoolCandidateBatchMutation();
  const [saveInstitutionAssignmentRequest] =
    useSaveInstitutionAssignmentMutation();
  const [setInstitutionAssignmentRequest] =
    useSetInstitutionAssignmentMutation();
  const [downloadSchoolCandidateResidencesRequest] =
    useDownloadSchoolCandidateResidencesMutation();

  const handleSearchNewResidences = async (
    request: SchoolCandidateNewResidencesRequest
  ) => {
    await triggerGetSchoolCandidateNewResidences(request);
  };

  return {
    authCounties,
    schoolCandidateNewResidences,
    isSchoolCandidateNewResidencesFetching,
    handleSearchNewResidences,
    startSchoolCandidateBatchRequest,
    saveInstitutionAssignmentRequest,
    setInstitutionAssignmentRequest,
    downloadSchoolCandidateResidencesRequest,
  };
};
